<template>
    <!-- ANFORDERUNGEN-V2 V2-03: gleiche Klassen wie die Nachbar-Kachel
         (ApartmentsNotes) — `w-full flex flex-col` füllt die
         Bildschirmhälfte, die `Show.vue` vorgibt (`lg:items-stretch`), statt
         auf den Inhalt zu schrumpfen. Ohne das entstand eine Lücke zur
         rechten Kachel und beide waren unterschiedlich hoch. -->
    <div
        class="border border-4 border-minplan-beige p-2 md:p-6 mt-6 w-full flex flex-col"
    >

        <h2 class="font-bold uppercase tracking-wider">{{ $t("apartments.pendingApprovals") }}</h2>
        <apartments-pending-approvals-items :pending-approvals="pendingApprovals"></apartments-pending-approvals-items>

        <!-- V2-03: `mt-auto` drückt die Zeile an den unteren Rand der Kachel,
             der "Erinnern"-Knopf sitzt damit nicht direkt unter dem Inhalt. -->
        <div v-if="sendReminderRoute" class="flex justify-between items-end mt-auto pt-4">
            <div>
                <div v-if="notReachableReason">
                    <span class="text-sm text-red-500">{{ $t(notReachableReason) }}</span>
                </div>
                <div v-if="lastReminded">
                    <span class="text-sm text-gray-500">{{ $t("apartments.lastReminded") }} {{ lastReminded }}</span>
                </div>
            </div>
            <primary-button @click="notify"
                            :disabled="!canRemind || pendingApprovals.modifications.length < 1 || buyersNotReachable">
                <BellIcon class="-ml-1 mr-2 h-5 w-5 text-minplan-darkgreybeige" />
                {{ $t("actions.remind") }}
            </primary-button>
        </div>

    </div>
</template>

<script>
import { BellIcon } from "@heroicons/vue/outline";
import ApartmentsPendingApprovalsItems from "@/Shared/Components/Apartments/ApartmentsPendingApprovalsItems";
import PrimaryButton from "@/Jetstream/PrimaryButton";

export default {
    props: ["pendingApprovals", "sendReminderRoute", "lastReminded", "canRemind", "buyersNotReachable", "buyers"],
    components: {
        BellIcon,
        ApartmentsPendingApprovalsItems,
        PrimaryButton
    },
    computed: {
        /**
         * Befund E-1 (UI-Abnahme 2026-09-21): Der Server meldet nur DASS
         * niemand erreichbar ist (`buyersNotReachable`), nicht warum. Seit dem
         * Riegel `Buyer::mayReceiveCommunication()` gibt es dafür zwei Gründe,
         * und der bisherige Satz nannte immer den ersten — auch bei einem
         * Käufer, dessen Schalter auf AN steht.
         *
         * Die Unterscheidung kommt ohne neue Prop aus: `buyers` trägt
         * `notify` und `invited` bereits.
         */
        notReachableReason() {
            const buyers = this.buyers || [];
            if (!this.buyersNotReachable || buyers.length === 0) return null;

            // Will überhaupt jemand benachrichtigt werden? Wenn nein, ist die
            // Abwahl der Grund — dann ändert eine Einladung nichts.
            const wollenBenachrichtigung = buyers.some((buyer) => buyer.notify);

            return wollenBenachrichtigung
                ? "apartments.buyerNotificationsNotInvited"
                : "apartments.buyerNotificationsNotActive";
        }
    },
    methods: {
        notify() {
            this.$inertia.put(
                this.sendReminderRoute, {},
                {
                    preserveState: false,
                    onSuccess: () => this.$notify({
                        group: "success",
                        title: "actions.success",
                        text: "apartments.reminderSent"
                    })
                }
            );
        }
    }
};
</script>

<style scoped>

</style>
